import React from 'react';
       
const AboutUsPage = () => {
    return (    

<div class="context">

<div style={{height:130, backgroundImage: `url(${"https://images.unsplash.com/photo-1576502200916-3808e07386a5?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1946&q=80"})`, text: 'About Us', fontSize: 60, color: 'white', textAlign:'center', paddingTop: 25}}>
  <div id="container">
    <div class="link"><b>About Us</b>
      <span class="tip" style={{width:500, fontSize: 30, padding: 100, borderRadius: 25}}>
      "A Fox one day spied a beautiful bunch of ripe grapes hanging from a vine trained along the branches of a tree.
       The grapes seemed ready to burst with juice, and the Fox's mouth watered as he gazed longingly at them."
      </span>
    </div>
  </div>
</div>

<div class="parallax"></div>

<div style={{height:300, backgroundImage: `url(${"https://images.unsplash.com/photo-1562619371-b67725b6fde2?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=1950&q=80"})`,fontSize: 30, color:'DarkViolet', textAlign:'center', paddingTop: 30}}>
    <b>The Crow & the Pitcher</b><br/><br/>
    In a spell of dry weather, when the Birds could find very little to drink, a thirsty Crow found a pitcher with a little water in it. 
    But the pitcher was high and had a narrow neck,
    and no matter how he tried, the Crow could not reach the water. The poor thing felt as if he must die of thirst.
</div>

<div class="parallax"></div>

<div style={{height:700, backgroundImage: `url(${"https://images.unsplash.com/photo-1557683316-973673baf926?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=2030&q=80"})`, color:'Navy', fontSize : 30, paddingLeft: 300, paddingTop: 20}}>
  React Dance &nbsp;&nbsp;Contact Us
</div>

<div class="parallax"></div>

      <div class="login-box">
        <h2>Contact Us</h2>
        <form>
          <div class="user-box">
            <input type="text" name="" required=""/>
            <label>Name</label>
          </div>
          <div class="user-box">
            <input type="email" name="" required=""/>
            <label>Email address</label>
          </div>
          <div class="user-box">
            <input type="question" name="" required="" style={{height: 80}}/>
            <label>Question</label>
          </div>
          <a href="#">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            Submit
          </a>
        </form>
      </div>    
</div>    
    );
}


export default AboutUsPage;
